<div class="training-page">
  <header class="page-header">
    <div>
      <p class="eyebrow">Training set</p>
      <h1>{{ session()?.name || 'Training Set' }}</h1>
      <p>{{ session()?.description || 'Upload plans, edit the AI drawings, and submit corrected examples.' }}</p>
    </div>
    <div class="top-actions">
      <button class="btn-light" type="button" (click)="goBack()">Back</button>
      <button class="btn-approve" type="button" (click)="setSessionStatus('Active')" [disabled]="session()?.status === 'Active'">Turn On</button>
      <button class="btn-reject" type="button" (click)="setSessionStatus('Disabled')" [disabled]="session()?.status === 'Disabled'">Turn Off</button>
    </div>
  </header>

  <section class="upload-panel">
    <div class="upload-copy">
      <h2>Add plan</h2>
      <p>Upload the original plan. The AI will create a drawing, then you can open it and correct the result.</p>
    </div>

    <div class="form-row">
      <label>
        <span>Title</span>
        <input [ngModel]="uploadTitle()" (ngModelChange)="uploadTitle.set($event)" placeholder="25 Muster Road">
      </label>
      <label>
        <span>Notes</span>
        <input [ngModel]="uploadNotes()" (ngModelChange)="uploadNotes.set($event)" placeholder="Optional notes for this plan">
      </label>
    </div>

    <label class="drop-zone single-drop">
      <input type="file" accept="image/*" (change)="chooseFile($event)" hidden>
      <ng-container *ngIf="uploadPreview(); else uploadEmpty">
        <img [src]="uploadPreview() || ''" alt="">
      </ng-container>
      <ng-template #uploadEmpty>
        <i class="ti ti-upload"></i>
        <strong>Original plan image</strong>
        <span>JPG, PNG, or WEBP</span>
      </ng-template>
    </label>

    <div class="upload-actions">
      <button class="btn-primary" type="button" (click)="addPlan()" [disabled]="isUploading()">
        {{ isUploading() ? 'Preparing AI Drawing...' : 'Add Plan' }}
      </button>
    </div>
  </section>

  <section class="samples-section">
    <div class="section-heading">
      <div>
        <h2>Plans in this set</h2>
        <p>Open each AI drawing, correct it in the full editor, then submit the example.</p>
      </div>
      <button class="btn-light" type="button" (click)="loadSession()" [disabled]="isLoading()">Refresh</button>
    </div>

    <div class="samples-grid" *ngIf="!isLoading(); else loadingState">
      <article class="sample-card compact-card" *ngFor="let sample of samples()" (click)="openEditor(sample)">
        <div class="sample-images single-image">
          <figure>
            <img *ngIf="imageHref(sample)" [src]="imageHref(sample)" alt="">
            <figcaption>Original Plan</figcaption>
          </figure>
        </div>

        <div class="sample-body">
          <div class="sample-topline">
            <span class="status-pill" [ngClass]="'status-' + statusLabel(sample).toLowerCase().replaceAll(' ', '-')">{{ statusLabel(sample) }}</span>
            <small>{{ formatDate(sample.created_at) }}</small>
          </div>
          <h3>{{ sample.title || 'Training plan' }}</h3>
          <p *ngIf="sample.ai_message" class="error-text">{{ sample.ai_message }}</p>
          <p *ngIf="!sample.ai_message">Open the drawing to review and correct the AI output.</p>
          <small *ngIf="sample.submitted_at">Submitted: {{ formatDate(sample.submitted_at) }}</small>
        </div>

        <div class="sample-actions">
          <button class="btn-primary" type="button" (click)="openEditor(sample); $event.stopPropagation()" [disabled]="statusLabel(sample) === 'Processing' || statusLabel(sample) === 'Failed'">Open Drawing</button>
          <button class="btn-approve" type="button" (click)="approve(sample, $event)" [disabled]="sample.status !== 'Submitted'">Approve</button>
          <button class="btn-reject" type="button" (click)="reject(sample, $event)" [disabled]="sample.status === 'Rejected'">Reject</button>
          <button class="btn-delete" type="button" (click)="deleteSample(sample, $event)">Delete</button>
        </div>
      </article>

      <div class="empty-state" *ngIf="samples().length === 0">
        <h3>No plans yet</h3>
        <p>Add a plan to create the first editable AI drawing for this training set.</p>
      </div>
    </div>

    <ng-template #loadingState>
      <div class="samples-grid">
        <div class="sample-card skeleton" *ngFor="let i of [1,2,3]"></div>
      </div>
    </ng-template>
  </section>
</div>
